import { useThemeContext } from '../../../features/Theme/providers/ThemeContextProvider';
import CloseIcon from '../../assets/icons/close_outer.svg?react';
import SuccessIcon from '../../assets/icons/success.svg?react';
import WarningIcon from '../../assets/icons/warning.svg?react';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import {
	AlertAbsolute,
	AlertAppend,
	AlertContainer,
	AlertLargeContainer,
	AlertLargeMessage,
	AlertLargePrepend,
	AlertMessage,
} from './style';
import { AlertProps } from './types';

const Alert = ({ type, message, onClose }: AlertProps) => {
	const theme = useThemeContext();
	const isDesktop = useIsDesktop();

	return (
		<AlertAbsolute data-testid="alert-container">
			{isDesktop && (
				<AlertLargeContainer type={type}>
					<AlertLargePrepend type={type}>
						{type === 'success' && <SuccessIcon data-testid="success-image" fill={theme.colors.success[300]} width={18} />}
						{type === 'warning' && <WarningIcon data-testid="warning-image" fill={theme.colors.warning[300]} width={18} />}
						{type === 'error' && <WarningIcon data-testid="error-image" fill={theme.colors.error[300]} width={18} />}
					</AlertLargePrepend>
					<AlertLargeMessage>{message}</AlertLargeMessage>
				</AlertLargeContainer>
			)}
			{!isDesktop && (
				<AlertContainer type={type}>
					<AlertMessage>{message}</AlertMessage>
					<AlertAppend>
						<CloseIcon
							data-testid="close-icon"
							fill={theme.colors[`${type}`][300]}
							width={18}
							onClick={() => {
								if (onClose) {
									onClose();
								}
							}}
						/>
					</AlertAppend>
				</AlertContainer>
			)}
		</AlertAbsolute>
	);
};

export { Alert };
